import React, { useEffect } from 'react';
import {
  Box,
  Center,
  Grid,
  Stack,
  Text,
  useBreakpointValue,
} from '@wegroup/design-system';
import ComparisonItemEmpty from '../../../../comparison/components/comparison-bar/ComparisonItemEmpty';
import { TOOLBAR_MAX_WIDTH } from '../../../../../components/toolbar/Toolbar';
import { getHubspotChatElement } from '../../../../../../../common/src/hooks/support-chat/useMoveHubspotBubble';
import useSelectedQuotesStore from '../../../store/zustand/selectedQuotes';
import SelectedQuoteItem from './SelectedQuoteItem';
import OfferCloseOnlineBottomBar from './OfferCloseOnlineBottomBar';
import { useTranslation } from 'react-i18next';

const NewOffersBottomBar: React.FC = () => {
  const { t } = useTranslation();
  const sliceAmount =
    useBreakpointValue({ base: 0, tablet: 2, desktopS: 3 }) || 0;
  const selectedQuotes = useSelectedQuotesStore(
    (state) => state.selectedQuotes,
  );
  const removeFromSelectedQuotes = useSelectedQuotesStore(
    (state) => state.remove,
  );
  const hubspotElement = getHubspotChatElement();

  useEffect(() => {
    if (selectedQuotes.length && hubspotElement) {
      hubspotElement.style.setProperty(
        'transition',
        'bottom 0.2s',
        'important',
      );
      if (sliceAmount === 0) {
        hubspotElement.style.setProperty('bottom', '60px', 'important');
      } else {
        hubspotElement.style.setProperty('bottom', '112px', 'important');
      }
    } else if (hubspotElement) {
      hubspotElement.style.setProperty('bottom', '0', 'important');
    }

    return () => {
      if (hubspotElement) {
        hubspotElement.style.setProperty('bottom', '0', 'important');
      }
    };
  }, [selectedQuotes.length]);

  const handleRemove = (id: string) => {
    removeFromSelectedQuotes(id);
  };

  return (
    <Box
      w="calc(100% - 12px)"
      boxShadow="level1"
      position="fixed"
      transform="auto"
      translateY={!selectedQuotes.length ? '100%' : '0'}
      transition="0.2s"
      bottom="0"
      left="0"
      pl={{ ...TOOLBAR_MAX_WIDTH, base: 0, laptop: TOOLBAR_MAX_WIDTH.base }}
      bg="white"
    >
      <Stack
        direction={{ base: 'column', tabletS: 'row' }}
        justify="space-between"
        spacing={{ base: '4', tablet: '6' }}
        align="center"
        p={{ base: 3, tablet: 6 }}
      >
        <Grid
          flexGrow="1"
          gridTemplateColumns={{
            base: 'repeat(1, 1fr) 80px',
            tabletS: 'repeat(2, 1fr) 80px',
            desktopS: 'repeat(3, 1fr) 80px',
          }}
          gridGap="4"
          display={{ base: 'none', tablet: 'grid' }}
        >
          {selectedQuotes.slice(0, sliceAmount).map((quote) => (
            <SelectedQuoteItem
              key={quote.id}
              quote={quote}
              onRemove={handleRemove}
            />
          ))}
          {selectedQuotes.length < 2 ? (
            <ComparisonItemEmpty
              placeholder={t('OFFERS_SELECTION_EMPTY_PLACEHOLDER')}
            />
          ) : (
            selectedQuotes.length > sliceAmount && (
              <ComparisonItemEmpty
                placeholder={`+ ${selectedQuotes.length - sliceAmount}`}
                color="black"
              />
            )
          )}
        </Grid>
        {sliceAmount === 0 && (
          <Text align="center" color="gray.500">
            {selectedQuotes.length} {t('SELECTED-OFFERS').toLowerCase()}
          </Text>
        )}
        <Center>
          <OfferCloseOnlineBottomBar
            offerIds={selectedQuotes.map(({ id }) => id)}
          />
        </Center>
      </Stack>
    </Box>
  );
};

export default NewOffersBottomBar;
